import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
// import NotFound from './components/pages/NotFound';
import Login from './components/Login';
import App from './App';

export default function Pages () {
    return <Router>
        <Switch>
            <Route exact path="/" render={() => <Redirect to="/sdk/android" push />} />
            <Route path="/login" component={Login} />
            <Route path="/" component={App} />
            {/* <Route path="/404" component={NotFound} /> */}
            {/* <Route component={NotFound} /> */}
        </Switch>
    </Router>
}